import { Dismissal } from '@app/types/api/job';

/**
 * Returns true if the given user currently has a dismissal on a case.
 * Dismissals do not expire — they are cleared by inbound message, global
 * address, or user unassignment.
 */
export const isCaseDismissedForUser = (
  dismissals: Dismissal[] | undefined,
  userId: string | undefined,
): boolean => dismissals?.some((d) => d.userId === userId) ?? false;
